import { render, staticRenderFns } from "./OcrPanel.vue?vue&type=template&id=34f8a1e4&scoped=true&"
import script from "./OcrPanel.vue?vue&type=script&lang=js&"
export * from "./OcrPanel.vue?vue&type=script&lang=js&"
import style0 from "./OcrPanel.vue?vue&type=style&index=0&id=34f8a1e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f8a1e4",
  null
  
)

export default component.exports